import {
  FETCH_PROMOTION_PRODUCTS_SUCCESS,
  FETCH_PROMOTION_PRODUCTS_FAILURE,
  FETCH_PROMOTION_PRODUCTS_REQUEST,
  RESET_PROMOTION_PRODUCTS_REQUEST,
  FETCH_EMPTY_SEARCH_LIST,
  GET_PROMOTION_SEARCH_PRODUCTS,
  GET_PROMOTION_SEARCH_PRODUCTS_SUCCESS,
  GET_PROMOTION_SEARCH_PRODUCTS_FAILURE,
  FETCH_SOP_PROFILE_REQUEST,
  FETCH_SOP_PROFILE_SUCCESS,
  FETCH_SOP_PROFILE_FAILURE,
  GET_PROMOTION_SEARCH_KEYWORDS,
  GET_PROMOTION_SEARCH_KEYWORDS_SUCCESS,
  GET_PROMOTION_SEARCH_KEYWORDS_FAILURE,
  FETCH_REGULAR_PRODUCT_CATEGORY_REQUEST,
  FETCH_REGULAR_PRODUCT_CATEGORY_SUCCESS,
  FETCH_REGULAR_PRODUCT_CATEGORY_FAILURE,
  FETCH_REGULAR_PRODUCT_SUB_CATEGORY_REQUEST,
  FETCH_REGULAR_PRODUCT_SUB_CATEGORY_SUCCESS,
  FETCH_REGULAR_PRODUCT_SUB_CATEGORY_FAILURE,
  FETCH_REGULAR_PRODUCT_REQUEST,
  FETCH_REGULAR_PRODUCT_SUCCESS,
  FETCH_REGULAR_PRODUCT_FAILURE,
  GET_PRODUCT_DETAIL_REQUEST,
  GET_PRODUCT_DETAIL_SUCCESS,
  GET_PRODUCT_DETAIL_FAILURE,
} from "../actions";
import {
  getProductDetailsById,
  getPromotionProducts,
  getPromotionSearchKeywords,
  getPromotionSearchProducts,
  getRegularProductCategoryList,
  getRegularProductsList,
  getRegularProductSubCategoryList,
} from "../services/promotion/lineOrdering.service";
import { getSOPProfileList } from "../services/sop-sub.service";

export const fetchDataRequest = (type, data = null) => ({ type, payload: data });
export const fetchDataSuccess = (type, data) => ({ type, payload: data });
export const fetchDataFailure = (type, error) => ({ type, payload: error });

export const fetchPromotionProducts = ({ type, ...params }) => dispatch => {
  dispatch(fetchDataRequest(FETCH_PROMOTION_PRODUCTS_REQUEST, { type }))
  return getPromotionProducts(params)
    .then((res) => {
      dispatch(fetchDataSuccess(FETCH_PROMOTION_PRODUCTS_SUCCESS, { data: res, type }));
      return res;
    }).catch(error => {
      dispatch(fetchDataFailure(FETCH_PROMOTION_PRODUCTS_FAILURE, error));
      return error;
    })
};

export const emptyPromotionSearch = () => (dispatch) =>
  dispatch(fetchDataRequest(FETCH_EMPTY_SEARCH_LIST));

export const fetchPromotionSearchProducts = (params) => dispatch => {
  dispatch(fetchDataRequest(GET_PROMOTION_SEARCH_PRODUCTS))
  return getPromotionSearchProducts(params)
    .then((res) => {
      dispatch(fetchDataSuccess(GET_PROMOTION_SEARCH_PRODUCTS_SUCCESS, res));
      return res;
    })
    .catch((error) => {
      dispatch(fetchDataFailure(GET_PROMOTION_SEARCH_PRODUCTS_FAILURE, error));
      return error;
    })
};

export const fetchSOPList = (filter, cartId, params) => async (dispatch) => {
  dispatch(fetchDataRequest(FETCH_SOP_PROFILE_REQUEST))
  try {
    const res = await getSOPProfileList(filter, cartId, { type: filter, ...params });
    dispatch(fetchDataSuccess(FETCH_SOP_PROFILE_SUCCESS, { data: res, type: filter }));
    return res;
  } catch (error) {
    dispatch(fetchDataFailure(FETCH_SOP_PROFILE_FAILURE, error));
    return error;
  }
}

export const fetchProductCategoryList = () => async (dispatch) => {
  dispatch(fetchDataRequest(FETCH_REGULAR_PRODUCT_CATEGORY_REQUEST));
  try {
    const res = await getRegularProductCategoryList();
    dispatch(fetchDataSuccess(FETCH_REGULAR_PRODUCT_CATEGORY_SUCCESS, { data: res }));
    return res;
  } catch (error) {
    dispatch(fetchDataFailure(FETCH_REGULAR_PRODUCT_CATEGORY_FAILURE, error));
    return error;
  }
}

export const fetchProductSubCategoryList = (categoryId) => async (dispatch) => {
  dispatch(fetchDataRequest(FETCH_REGULAR_PRODUCT_SUB_CATEGORY_REQUEST));
  try {
    const res = await getRegularProductSubCategoryList(categoryId);
    dispatch(fetchDataSuccess(FETCH_REGULAR_PRODUCT_SUB_CATEGORY_SUCCESS, { data: res, categoryId }));
    return res;
  } catch (error) {
    dispatch(fetchDataFailure(FETCH_REGULAR_PRODUCT_SUB_CATEGORY_FAILURE, error));
    return error;
  }
}

export const fetchRegularProductsList = (params) => async (dispatch) => {
  dispatch(fetchDataRequest(FETCH_REGULAR_PRODUCT_REQUEST, { params }));
  try {
    const res = await getRegularProductsList(params);
    dispatch(fetchDataSuccess(FETCH_REGULAR_PRODUCT_SUCCESS, { data: res, params }));
    return res;
  } catch (error) {
    dispatch(fetchDataFailure(FETCH_REGULAR_PRODUCT_FAILURE, error));
    return error;
  }
}

export const fetchPromotionSearchKeywords = (params) => dispatch => {
  dispatch(fetchDataRequest(GET_PROMOTION_SEARCH_KEYWORDS));
  return getPromotionSearchKeywords(params)
    .then((res) => {
      dispatch(fetchDataSuccess(GET_PROMOTION_SEARCH_KEYWORDS_SUCCESS, res));
      return res;
    })
    .catch((error) => {
      dispatch(fetchDataFailure(GET_PROMOTION_SEARCH_KEYWORDS_FAILURE, error));
      return error;
    })
}

export const fetchProductDetails = (productId) => dispatch => {
  dispatch(fetchDataRequest(GET_PRODUCT_DETAIL_REQUEST))
  return getProductDetailsById(productId)
    .then((res) => {
      dispatch(fetchDataSuccess(GET_PRODUCT_DETAIL_SUCCESS, res));
      return res;
    })
    .catch((error) => {
      dispatch(fetchDataFailure(GET_PRODUCT_DETAIL_FAILURE, error));
      return error;
    })
};